import { api } from './index';
import type { ClinicalAuthor } from '../utils/clinical-author';
import type { ClinicalVoidable } from '../utils/clinical-void';

const BASE_PATH = '/api/internal/incident_records';

export type IncidentRecord = ClinicalVoidable & {
  id: number;
  observations?: string;
  reportedAt: string;
  humanReportedAt: string;
  incidentDefinitionName: string;
  incidentDefinitionDescription: string;
  author: ClinicalAuthor | null;
};

export const incidentRecordsApi = {
  indexByShift(shiftId: number): Promise<IncidentRecord[]> {
    return api({
      method: 'get',
      url: `${BASE_PATH}?shift_id=${shiftId}`,
    }).then(response => response.data.incidentRecords);
  },
};
